import React from "react";
import PrivavcyBg from "../assets/img/privavcy-bg.jpg";
import { Link } from "react-router-dom";
import thanks from "../assets/img/thanks.png";

const TermsAndConditions: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Page Title Area */}
      <div
        className="relative h-[500px] bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${PrivavcyBg})` }}
      >
        {/* Optional dark overlay */}
        <div className="absolute inset-0 bg-black opacity-50 z-10"></div>

        {/* Text on top */}
        <div className="relative z-20 container mx-auto px-4 h-full flex flex-col justify-center items-center text-white text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Terms And Conditions
          </h1>
          <nav className="flex justify-center items-center space-x-2 text-sm">
            <Link to="/" className="hover:text-blue-300 transition-colors">
              Home
            </Link>
            <span className="text-gray-300">/</span>
            <span className="text-gray-300">Terms And Conditions</span>
          </nav>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <h3 className="mt-0 text-2xl font-bold text-gray-800  border-b-2 border-blue-500 pb-3">
          We are committed to protecting your privacy
        </h3>
        <p className="text-gray-700 leading-relaxed mb-3 text-lg">
          By agreeing to these terms and conditions, you agree to the terms of
          our Privacy Policy. Please carefully review our Privacy Policy in
          prior to the use of this website. All Personal Information provided to
          us as a result of your use of this website will be handled in
          accordance with our Privacy Policy. If there is any disagreement,
          please refrain from using this website.
        </p>
        <p className="text-gray-700 leading-relaxed mb-6 text-lg">
          {" "}
          Elenoit Digital Solution Pvt. Ltd. (hereafter, called as ‘Elenoit’)
          may, without notice to you, at any time, amend these Terms of Use and
          any other information contained in this website. Elenoit may also make
          improvements or changes in the products, services, or programs
          described in this site at any time without notice.
        </p>

        <h3 className="mt-0 text-2xl font-bold text-gray-800  border-b-2 border-blue-500 pb-3">
          General Terms
        </h3>
        <p className="text-gray-700 leading-relaxed mb-3 text-lg">
          The information provided on this website is for informational purposes
          only and it does not create a business or professional services
          relationship between you and Elenoit.
        </p>
        <p className="text-gray-700 leading-relaxed mb-3 text-lg">
          Elenoit grants you a non-exclusive, non-transferable, limited
          permission to access and display the web-pages within this site as a
          customer or prospective customer provided you comply with these Terms
          of Use, and all copyright, trademark, and other proprietary notices
          remain intact. The use authorized under this agreement is
          non-commercial in nature (e.g., the content you access on or through
          this website are non-tradable.) All other use of this site is
          prohibited.
        </p>
        <p className="text-gray-700 leading-relaxed  mb-6 text-lg">
          Except for the limited permission in the preceding paragraph, Elenoit
          does not grant you any express or implied rights or licenses under any
          patents, trademarks, copyrights, or other proprietary or intellectual
          property rights. Any content from this site cannot be cloned on
          another website or in any other forms of media. Any software and other
          materials available for access, downloading or other use from this
          website with their own license terms will be governed by such terms,
          conditions, and notifications. The failure to comply with such terms
          or any of the terms on this website will result in automatic
          termination of any rights granted, without prior notice, and all
          copies of downloaded materials in your possession, custody or control
          must be destroyed immediately.
        </p>

        <h3 className="mt-0 text-2xl font-bold text-gray-800  border-b-2 border-blue-500 pb-3">
          Trademarks
        </h3>
        <p className="text-gray-700 leading-relaxed mb-6 text-lg">
          The names and logos of Elenoit and its affiliates, all product names,
          all page headers, all custom graphics, all button icons, and all
          trademarks, service marks and logos appearing on this website, unless
          otherwise noted, are trademarks (whether registered or not), service
          marks and/or trade dress of Elenoit and its affiliates. All other
          trademarks, product names, company names, logos, service marks and/or
          trade dress mentioned, displayed, cited or otherwise indicated on this
          website are the property of their respective owners. You are not
          authorized to display or use these in any manner without our prior
          written permission. You are not authorized to display or use
          trademarks, product names, company names, logos, service marks and/or
          trade dress of other owners featured on this website without the prior
          written permission of such owners. Any use or misuse is expressly
          prohibited.
        </p>

        <h3 className="mt-0 text-2xl font-bold text-gray-800  border-b-2 border-blue-500 pb-3">
          Disclaimer Of Warranties
        </h3>
        <p className="text-gray-700 leading-relaxed mb-3 text-lg">
          Elenoit attempts to provide accurate Content on the website. However,
          it makes no representation, endorsement or warranty that such Content
          is accurate or suitable for any particular purpose.
        </p>
        <p className="text-gray-700 leading-relaxed mb-3 text-lg">
          The website and its Content are provided "as is" with no warranties or
          guarantees whatsoever. Use of the website and its Content is at the
          user's sole risk. The website and Content are provided without any
          representations, endorsements, or warranties of any kind whatsoever,
          either expressed or implied, including, but not limited to, any
          warranties of title or accuracy and any implied warranties of
          merchantability, fitness for a particular purpose or non infringement,
          with the sole exception of warranties (if any) which cannot be
          expressly excluded under applicable law. Elenoit also makes no
          representations, endorsements or warranties, either express or
          implied, with respect to any website operated by a third party as
          well. Without limitation, Elenoit makes no warranty or guarantee that
          this web site will be uninterrupted, timely, secure, or error-free.
        </p>
        <p className="text-gray-700 leading-relaxed mb-6 text-lg">
          If you download or otherwise obtain materials, information, products,
          software, programs, or services from this web site, you do so at your
          own discretion and risk and that you will be solely responsible for
          any damages that may result, including loss of data or damage to your
          computer system.
        </p>

        <h3 className="mt-0 text-2xl font-bold text-gray-800  border-b-2 border-blue-500 pb-3">
          Limitation Of Liability
        </h3>
        <p className="text-gray-700 leading-relaxed mb-3 text-lg">
          To the fullest extent permitted by applicable law, in no event will
          Elenoit be liable to any party for any damages, including, without
          limitation, indirect, incidental, special, exemplary, consequential or
          punitive damages, whether under a contract, tort or any other theory
          of liability, arising in connection with any party's use of the
          website or in connection with any failure of performance, error,
          omission, interruption, defect, delay in operation or transmission,
          computer virus, line system failure, loss of data or loss of use
          related to this website or of any other site or resource linked to,
          referenced, or accessed through this web site, even if Elenoit is
          expressly advised of the possibility of such damages. This exclusion
          and waiver of liability applies to all causes of action, whether based
          on contract, warranty, tort, or any other legal theories.
        </p>
        <p className="text-gray-700 leading-relaxed mb-6 text-lg">
          To the fullest extent permitted by applicable law, in no event will
          Elenoit be liable to any party for any damages, including, without
          limitation, indirect, incidental, special, exemplary, consequential or
          punitive damages, whether under a contract, tort or any other theory
          of liability, arising in connection with any party's use of the
          website or in connection with any failure of performance, error,
          omission, interruption, defect, delay in operation or transmission,
          computer virus, line system failure, loss of data or loss of use
          related to this website or of any other site or resource linked to,
          referenced, or accessed through this web site, even if Elenoit is
          expressly advised of the possibility of such damages. This exclusion
          and waiver of liability applies to all causes of action, whether based
          on contract, warranty, tort, or any other legal theories.
        </p>

        <h3 className="mt-0 text-2xl font-bold text-gray-800  border-b-2 border-blue-500 pb-3">
          Links To Other Sites
        </h3>
        <p className="text-gray-700 leading-relaxed mb-6 text-lg">
          Elenoit may establish links between this website and one or more
          websites operated by third parties. The existence of any such links
          shall not constitute an endorsement, representation or warranty by
          Elenoit of such websites, the contents of the websites, the products
          or services of the websites or the operators of the websites. Elenoit
          is not oblige to investigate, monitor or check such websites for
          accuracy, completeness or conformance with applicable laws and
          regulations. If there is any will to leave this website and access
          these other websites, all rules, policies (including privacy policies)
          and operating procedures of such websites will apply to you while on
          such websites.
        </p>

        <h3 className="mt-0 text-2xl font-bold text-gray-800  border-b-2 border-blue-500 pb-3">
          Removal Of Links From Our Website
        </h3>
        <p className="text-gray-700 leading-relaxed mb-3 text-lg">
          If you find any link on our website to be offensive due to any reason,
          you are free to contact and inform us anytime. We will consider
          requests to remove links but we are not obliged to or so or to respond
          to you directly.
        </p>
        <p className="text-gray-700 leading-relaxed mb-6 text-lg">
          There is no assertion that the information on this website is fully
          correct, we do not warrant its completeness or accuracy; nor do we
          promise to ensure that the website remains available or that the
          material on the website is kept up to date.
        </p>

        <h3 className="mt-0 text-2xl font-bold text-gray-800  border-b-2 border-blue-500 pb-3">
          Modifications
        </h3>
        <p className="text-gray-700 leading-relaxed mb-3 text-lg">
          The content on this website should only be considered current as of
          the date of initial publication appearing thereon, without regard to
          the date on which the information is accessed.
        </p>
        <p className="text-gray-700 leading-relaxed mb-6 text-lg">
          Elenoit reserves the right to update and revise any type of content of
          this website, at any time, without prior notice. You are responsible
          for regularly reviewing these terms and conditions. Your continued use
          of this website following any modifications, changes or alterations
          shall constitute your acceptance of such modifications, changes or
          alterations.
        </p>

        <h3 className="mt-0 text-2xl font-bold text-gray-800  border-b-2 border-blue-500 pb-3">
          Law And Jurisdiction
        </h3>
        <p className="text-gray-700 leading-relaxed mb-3 text-lg">
          You agree that these terms of use and any legal action or proceeding
          relating to this website are subject to the laws of the Republic of
          India and the courts in Mumbai, India shall have the jurisdiction on
          any dispute that may arise out of the use of this site.
        </p>
        <p className="text-gray-700 leading-relaxed mb-6 text-lg">
          You are responsible for complying with the laws of the jurisdiction
          from which you are accessing this website and you agree that you will
          access or use the information on this website as per the existing
          laws. Any information disclosed to Elenoit outside a preceding and
          documented confidential business relationship will be considered as
          non-confidential and non-proprietary, and Elenoit may therefore
          develop, use and freely disclose or publish similar ideas without any
          compensation and accountability.
        </p>

        <h3 className="mt-0 text-2xl font-bold text-gray-800  border-b-2 border-blue-500 pb-3">
          Contact
        </h3>
        <p className="text-gray-700 leading-relaxed mb-6 text-lg">
          You may reach out to Elenoit by e-mail at
          <span>
            <a href="mailto:enquiry@elenoit.com">enquiry@elenoit.com</a>
          </span>
        </p>
      </div>
      <div className="container mx-auto px-4 text-center mb-10"></div>
    </div>
  );
};

export default TermsAndConditions;
